import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';

/**
 * Monitors the URL for ?lang=en or ?lang=el and updates the global context.
 */
const LanguageSync = () => {
  const location = useLocation();
  const { changeLanguage } = useLanguage();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const langParam = params.get('lang');
    
    if (langParam === 'en' || langParam === 'el') {
      changeLanguage(langParam);
    }
  }, [location, changeLanguage]);

  return null;
};

export default LanguageSync;